webpackJsonp([35783957827783],{

/***/ 310:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(24);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(42);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(41);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _objectWithoutProperties2 = __webpack_require__(126);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(125);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Handle legacy names for image queries.
	var convertProps = function convertProps(props) {
	  var convertedProps = (0, _extends3.default)({}, props);
	  if (convertedProps.responsiveResolution) {
	    convertedProps.resolutions = convertedProps.responsiveResolution;
	    delete convertedProps.responsiveResolution;
	  }
	  if (convertedProps.responsiveSizes) {
	    convertedProps.sizes = convertedProps.responsiveSizes;
	    delete convertedProps.responsiveSizes;
	  }
	
	  return convertedProps;
	};
	
	// Cache if we've seen an image before so we don't both with
	// lazy-loading & fading in on subsequent mounts.
	var imageCache = {};
	var inImageCache = function inImageCache(props) {
	  var convertedProps = convertProps(props);
	  // Find src
	  var src = convertedProps.sizes ? convertedProps.sizes.src : convertedProps.resolutions.src;
	
	  if (imageCache[src]) {
	    return true;
	  } else {
	    imageCache[src] = true;
	    return false;
	  }
	};
	
	var io = void 0;
	var listeners = [];
	
	function getIO() {
	  if (typeof io === "undefined" && typeof window !== "undefined" && window.IntersectionObserver) {
	    io = new window.IntersectionObserver(function (entries) {
	      entries.forEach(function (entry) {
	        listeners.forEach(function (l) {
	          if (l[0] === entry.target) {
	            // Edge doesn't currently support isIntersecting, so also test for an intersectionRatio > 0
	            if (entry.isIntersecting || entry.intersectionRatio > 0) {
	              io.unobserve(l[0]);
	              l[1]();
	            }
	          }
	        });
	      });
	    }, { rootMargin: "200px" });
	  }
	
	  return io;
	}
	
	var listenToIntersections = function listenToIntersections(el, cb) {
	  getIO().observe(el);
	  listeners.push([el, cb]);
	};
	
	var isWebpSupportedCache = null;
	var isWebpSupported = function isWebpSupported() {
	  if (isWebpSupportedCache !== null) {
	    return isWebpSupportedCache;
	  }
	
	  var elem = typeof window !== "undefined" ? window.document.createElement("canvas") : {};
	  if (elem.getContext && elem.getContext("2d")) {
	    isWebpSupportedCache = elem.toDataURL("image/webp").indexOf("data:image/webp") === 0;
	  } else {
	    isWebpSupportedCache = false;
	  }
	
	  return isWebpSupportedCache;
	};
	
	var noscriptImg = function noscriptImg(props) {
	  var _props$opacity = props.opacity,
	      opacity = _props$opacity === undefined ? "1" : _props$opacity,
	      src = props.src,
	      srcSet = props.srcSet,
	      _props$sizes = props.sizes,
	      sizes = _props$sizes === undefined ? "" : _props$sizes,
	      _props$title = props.title,
	      title = _props$title === undefined ? "" : _props$title,
	      _props$alt = props.alt,
	      alt = _props$alt === undefined ? "" : _props$alt,
	      _props$width = props.width,
	      width = _props$width === undefined ? "" : _props$width,
	      _props$height = props.height,
	      height = _props$height === undefined ? "" : _props$height,
	      _props$transitionDela = props.transitionDelay,
	      transitionDelay = _props$transitionDela === undefined ? "0.5s" : _props$transitionDela;
	
	  return "<img width=\"" + width + "\" height=\"" + height + "\" src=\"" + src + "\" srcset=\"" + srcSet + "\" alt=\"" + alt + "\" title=\"" + title + "\" sizes=\"" + sizes + "\" style=\"position:absolute;top:0;left:0;transition:opacity 0.5s;transition-delay:" + transitionDelay + ";opacity:" + opacity + ";width:100%;height:100%;object-fit:cover;object-position:center\"/>";
	};
	
	var Img = function Img(props) {
	  var style = props.style,
	      onLoad = props.onLoad,
	      otherProps = (0, _objectWithoutProperties3.default)(props, ["style", "onLoad"]);
	
	  return _react2.default.createElement("img", (0, _extends3.default)({}, otherProps, {
	    onLoad: onLoad,
	    style: (0, _extends3.default)({
	      position: "absolute",
	      top: 0,
	      left: 0,
	      transition: "opacity 0.5s",
	      width: "100%",
	      height: "100%",
	      objectFit: "cover",
	      objectPosition: "center"
	    }, style)
	  }));
	};
	
	Img.propTypes = {
	  style: _propTypes2.default.object,
	  onLoad: _propTypes2.default.func
	};
	
	var Image = function (_React$Component) {
	  (0, _inherits3.default)(Image, _React$Component);
	
	  function Image(props) {
	    (0, _classCallCheck3.default)(this, Image);
	
	    // If this browser doesn't support the IntersectionObserver API
	    // we default to start downloading the image right away.
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props));
	
	    var isVisible = true;
	    var imgLoaded = true;
	    var IOSupported = false;
	
	    // If this image has already been loaded before then we can assume it's
	    // already in the browser cache so it's cheap to just show directly.
	    var seenBefore = inImageCache(props);
	
	    if (!seenBefore && typeof window !== "undefined" && window.IntersectionObserver) {
	      isVisible = false;
	      imgLoaded = false;
	      IOSupported = true;
	    }
	
	    // Always don't render image while server rendering
	    if (typeof window === "undefined") {
	      isVisible = false;
	      imgLoaded = false;
	    }
	
	    _this.state = {
	      isVisible: isVisible,
	      imgLoaded: imgLoaded,
	      IOSupported: IOSupported
	    };
	
	    _this.handleRef = _this.handleRef.bind(_this);
	    return _this;
	  }
	
	  Image.prototype.handleRef = function handleRef(ref) {
	    var _this2 = this;
	
	    if (this.state.IOSupported && ref) {
	      listenToIntersections(ref, function () {
	        _this2.setState({ isVisible: true, imgLoaded: false });
	      });
	    }
	  };
	
	  Image.prototype.render = function render() {
	    var _this3 = this;
	
	    var _convertProps = convertProps(this.props),
	        title = _convertProps.title,
	        alt = _convertProps.alt,
	        className = _convertProps.className,
	        outerWrapperClassName = _convertProps.outerWrapperClassName,
	        _convertProps$style = _convertProps.style,
	        style = _convertProps$style === undefined ? {} : _convertProps$style,
	        _convertProps$imgStyl = _convertProps.imgStyle,
	        imgStyle = _convertProps$imgStyl === undefined ? {} : _convertProps$imgStyl,
	        sizes = _convertProps.sizes,
	        resolutions = _convertProps.resolutions,
	        backgroundColor = _convertProps.backgroundColor,
	        Tag = _convertProps.Tag;
	
	    var bgColor = void 0;
	    if (typeof backgroundColor === "boolean") {
	      bgColor = "lightgray";
	    } else {
	      bgColor = backgroundColor;
	    }
	
	    var imagePlaceholderStyle = (0, _extends3.default)({
	      opacity: this.state.imgLoaded ? 0 : 1,
	      transitionDelay: "0.25s"
	    }, imgStyle);
	
	    var imageStyle = (0, _extends3.default)({
	      opacity: this.state.imgLoaded || this.props.fadeIn === false ? 1 : 0
	    }, imgStyle);
	
	    if (sizes) {
	      var image = sizes;
	
	      // Use webp by default if browser supports it
	      if (image.srcWebp && image.srcSetWebp && isWebpSupported()) {
	        image.src = image.srcWebp;
	        image.srcSet = image.srcSetWebp;
	      }
	
	      // The outer div is necessary to reset the z-index to 0.
	      return _react2.default.createElement(
	        Tag,
	        {
	          className: (outerWrapperClassName ? outerWrapperClassName : "") + " gatsby-image-outer-wrapper",
	          style: {
	            // Let users set component to be absolutely positioned.
	            position: style.position === "absolute" ? "initial" : "relative"
	          }
	        },
	        _react2.default.createElement(
	          Tag,
	          {
	            className: (className ? className : "") + " gatsby-image-wrapper",
	            style: (0, _extends3.default)({
	              position: "relative",
	              overflow: "hidden"
	            }, style),
	            ref: this.handleRef
	          },
	          _react2.default.createElement(Tag, {
	            style: {
	              width: "100%",
	              paddingBottom: 100 / image.aspectRatio + "%"
	            }
	          }),
	          image.base64 && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: image.base64,
	            style: imagePlaceholderStyle
	          }),
	          image.tracedSVG && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: image.tracedSVG,
	            style: imagePlaceholderStyle
	          }),
	          bgColor && _react2.default.createElement(Tag, {
	            title: title,
	            style: {
	              backgroundColor: bgColor,
	              position: "absolute",
	              top: 0,
	              bottom: 0,
	              opacity: !this.state.imgLoaded ? 1 : 0,
	              transitionDelay: "0.35s",
	              right: 0,
	              left: 0
	            }
	          }),
	          this.state.isVisible && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            srcSet: image.srcSet,
	            src: image.src,
	            sizes: image.sizes,
	            style: imageStyle,
	            onLoad: function onLoad() {
	              _this3.state.IOSupported && _this3.setState({ imgLoaded: true });
	              _this3.props.onLoad && _this3.props.onLoad();
	            }
	          }),
	          _react2.default.createElement("noscript", {
	            dangerouslySetInnerHTML: {
	              __html: noscriptImg((0, _extends3.default)({ alt: alt, title: title }, image))
	            }
	          })
	        )
	      );
	    }
	
	    if (resolutions) {
	      var _image = resolutions;
	      var divStyle = (0, _extends3.default)({
	        position: "relative",
	        overflow: "hidden",
	        display: "inline-block",
	        width: _image.width,
	        height: _image.height
	      }, style);
	
	      if (style.display === "inherit") {
	        delete divStyle.display;
	      }
	
	      // Use webp by default if browser supports it
	      if (_image.srcWebp && _image.srcSetWebp && isWebpSupported()) {
	        _image.src = _image.srcWebp;
	        _image.srcSet = _image.srcSetWebp;
	      }
	
	      // The outer div is necessary to reset the z-index to 0.
	      return _react2.default.createElement(
	        Tag,
	        {
	          className: (outerWrapperClassName ? outerWrapperClassName : "") + " gatsby-image-outer-wrapper",
	          style: {
	            // Let users set component to be absolutely positioned.
	            position: style.position === "absolute" ? "initial" : "relative"
	          }
	        },
	        _react2.default.createElement(
	          Tag,
	          {
	            className: (className ? className : "") + " gatsby-image-wrapper",
	            style: divStyle,
	            ref: this.handleRef
	          },
	          _image.base64 && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: _image.base64,
	            style: imagePlaceholderStyle
	          }),
	          _image.tracedSVG && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: _image.tracedSVG,
	            style: imagePlaceholderStyle
	          }),
	          bgColor && _react2.default.createElement(Tag, {
	            title: title,
	            style: {
	              backgroundColor: bgColor,
	              width: _image.width,
	              opacity: !this.state.imgLoaded ? 1 : 0,
	              transitionDelay: "0.25s",
	              height: _image.height
	            }
	          }),
	          this.state.isVisible && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            width: _image.width,
	            height: _image.height,
	            srcSet: _image.srcSet,
	            src: _image.src,
	            style: imageStyle,
	            onLoad: function onLoad() {
	              _this3.setState({ imgLoaded: true });
	              _this3.props.onLoad && _this3.props.onLoad();
	            }
	          }),
	          _react2.default.createElement("noscript", {
	            dangerouslySetInnerHTML: {
	              __html: noscriptImg((0, _extends3.default)({
	                alt: alt,
	                title: title,
	                width: _image.width,
	                height: _image.height
	              }, _image))
	            }
	          })
	        )
	      );
	    }
	
	    return null;
	  };
	
	  return Image;
	}(_react2.default.Component);
	
	Image.defaultProps = {
	  fadeIn: true,
	  alt: "",
	  Tag: "div"
	};
	
	Image.propTypes = {
	  responsiveResolution: _propTypes2.default.object,
	  responsiveSizes: _propTypes2.default.object,
	  resolutions: _propTypes2.default.object,
	  sizes: _propTypes2.default.object,
	  fadeIn: _propTypes2.default.bool,
	  title: _propTypes2.default.string,
	  alt: _propTypes2.default.string,
	  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]), // Support Glamor's css prop.
	  outerWrapperClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  style: _propTypes2.default.object,
	  imgStyle: _propTypes2.default.object,
	  position: _propTypes2.default.string,
	  backgroundColor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool]),
	  onLoad: _propTypes2.default.func,
	  Tag: _propTypes2.default.string
	};
	
	exports.default = Image;

/***/ }),

/***/ 159:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.hoistNonReactStatics = factory());
	}(this, (function () {
	    'use strict';
	    
	    var REACT_STATICS = {
	        childContextTypes: true,
	        contextTypes: true,
	        defaultProps: true,
	        displayName: true,
	        getDefaultProps: true,
	        getDerivedStateFromProps: true,
	        mixins: true,
	        propTypes: true,
	        type: true
	    };
	    
	    var KNOWN_STATICS = {
	        name: true,
	        length: true,
	        prototype: true,
	        caller: true,
	        callee: true,
	        arguments: true,
	        arity: true
	    };
	    
	    var defineProperty = Object.defineProperty;
	    var getOwnPropertyNames = Object.getOwnPropertyNames;
	    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	    var getPrototypeOf = Object.getPrototypeOf;
	    var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	    
	    return function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	        if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	            
	            if (objectPrototype) {
	                var inheritedComponent = getPrototypeOf(sourceComponent);
	                if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                    hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	                }
	            }
	            
	            var keys = getOwnPropertyNames(sourceComponent);
	            
	            if (getOwnPropertySymbols) {
	                keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	            }
	            
	            for (var i = 0; i < keys.length; ++i) {
	                var key = keys[i];
	                if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                    var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                    try { // Avoid failures from read-only properties
	                        defineProperty(targetComponent, key, descriptor);
	                    } catch (e) {}
	                }
	            }
	            
	            return targetComponent;
	        }
	        
	        return targetComponent;
	    };
	})));


/***/ }),

/***/ 335:
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        result = wait - timeSinceLastCall;
	
	    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	/**
	 * Creates a throttled function that only invokes `func` at most once per
	 * every `wait` milliseconds. The throttled function comes with a `cancel`
	 * method to cancel delayed `func` invocations and a `flush` method to
	 * immediately invoke them. Provide `options` to indicate whether `func`
	 * should be invoked on the leading and/or trailing edge of the `wait`
	 * timeout. The `func` is invoked with the last arguments provided to the
	 * throttled function. Subsequent calls to the throttled function return the
	 * result of the last `func` invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the throttled function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.throttle` and `_.debounce`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to throttle.
	 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=true]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new throttled function.
	 * @example
	 *
	 * // Avoid excessively updating the position while scrolling.
	 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	 *
	 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	 * jQuery(element).on('click', throttled);
	 *
	 * // Cancel the trailing throttled invocation.
	 * jQuery(window).on('popstate', throttled.cancel);
	 */
	function throttle(func, wait, options) {
	  var leading = true,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  if (isObject(options)) {
	    leading = 'leading' in options ? !!options.leading : leading;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	  return debounce(func, wait, {
	    'leading': leading,
	    'maxWait': wait,
	    'trailing': trailing
	  });
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = throttle;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 407:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(335);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* global window, document */
	
	
	var TrackVisibility = function (_Component) {
	  _inherits(TrackVisibility, _Component);
	
	  function TrackVisibility(props) {
	    _classCallCheck(this, TrackVisibility);
	
	    var _this = _possibleConstructorReturn(this, (TrackVisibility.__proto__ || Object.getPrototypeOf(TrackVisibility)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    _this.state = {
	      isVisible: false
	    };
	    _this.throttleCb = (0, _lodash2.default)(_this.isComponentVisible, _this.props.throttleInterval);
	
	    props.nodeRef && _this.setNodeRef(props.nodeRef);
	    return _this;
	  }
	
	  _createClass(TrackVisibility, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.attachListener();
	      setTimeout(function () {
	        return _this2.isComponentVisible();
	      }, 0);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.removeListener();
	    }
	  }, {
	    key: "attachListener",
	    value: function attachListener() {
	      window.addEventListener("scroll", this.throttleCb);
	      window.addEventListener("resize", this.throttleCb);
	    }
	  }, {
	    key: "removeListener",
	    value: function removeListener() {
	      window.removeEventListener("scroll", this.throttleCb);
	      window.removeEventListener("resize", this.throttleCb);
	    }
	  }, {
	    key: "getChildProps",
	    value: function getChildProps() {
	      var _this3 = this;
	
	      var props = {};
	      Object.keys(this.props).forEach(function (key) {
	        if (!{}.hasOwnProperty.call(TrackVisibility.defaultProps, key)) {
	          props[key] = _this3.props[key];
	        }
	      });
	      return props;
	    }
	  }, {
	    key: "getChildren",
	    value: function getChildren() {
	      var _this4 = this;
	
	      if (typeof this.props.children === "function") {
	        return this.props.children(Object.assign({}, this.getChildProps(), {
	          isVisible: this.state.isVisible
	        }));
	      }
	
	      return _react2.default.Children.map(this.props.children, function (child) {
	        return _react2.default.cloneElement(child, Object.assign({}, _this4.getChildProps(), {
	          isVisible: _this4.state.isVisible
	        }));
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          style = _props.style,
	          nodeRef = _props.nodeRef;
	
	      var props = Object.assign({}, className !== null && { className: className }, style !== null && { style: style });
	
	      return _react2.default.createElement(
	        "div",
	        Object.assign({ ref: !nodeRef && this.setNodeRef }, props),
	        this.getChildren()
	      );
	    }
	  }]);
	
	  return TrackVisibility;
	}(_react.Component);
	
	TrackVisibility.propTypes = {
	  /**
	   * Define if the visibility need to be tracked once
	   */
	  once: _propTypes2.default.bool,
	
	  /**
	   * Tweak the throttle interval
	   * Check https://css-tricks.com/debouncing-throttling-explained-examples/ for more details
	   */
	  throttleInterval: function throttleInterval(props, propName, component) {
	    var currentProp = props[propName];
	    if (!Number.isInteger(currentProp) || currentProp < 0) {
	      return new Error("The " + propName + " prop you provided to " + component + " is not a valid integer >= 0.");
	    }
	    return null;
	  },
	
	  /**
	   * Pass one or more children to track
	   */
	  children: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element, _propTypes2.default.arrayOf(_propTypes2.default.element)]),
	  /**
	   * Additional style to apply
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * Additional className to apply
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * Define an offset. Can be useful for lazy loading
	   */
	  offset: _propTypes2.default.number,
	
	  /**
	   * Update the visibility state as soon as a part of the tracked component is visible
	   */
	  partialVisibility: _propTypes2.default.bool,
	
	  /**
	   * Exposed for testing but allows node other than internal wrapping <div /> to be tracked
	   * for visibility
	   */
	  nodeRef: _propTypes2.default.object
	};
	TrackVisibility.defaultProps = {
	  once: false,
	  throttleInterval: 150,
	  style: null,
	  className: null,
	  offset: 0,
	  children: null,
	  partialVisibility: false,
	  nodeRef: null
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this5 = this;
	
	  this.isVisible = function (_ref, windowWidth, windowHeight) {
	    var top = _ref.top,
	        left = _ref.left,
	        bottom = _ref.bottom,
	        right = _ref.right,
	        width = _ref.width,
	        height = _ref.height;
	    var _props2 = _this5.props,
	        offset = _props2.offset,
	        partialVisibility = _props2.partialVisibility;
	
	
	    if (top + right + bottom + left === 0) {
	      return false;
	    }
	
	    var topThreshold = 0 - offset;
	    var leftThreshold = 0 - offset;
	    var widthCheck = windowWidth + offset;
	    var heightCheck = windowHeight + offset;
	
	    return partialVisibility ? top + height >= topThreshold && left + width >= leftThreshold && bottom - height <= heightCheck && right - width <= widthCheck : top >= topThreshold && left >= leftThreshold && bottom <= heightCheck && right <= widthCheck;
	  };
	
	  this.isComponentVisible = function () {
	    var html = document.documentElement;
	    var once = _this5.props.once;
	
	    var boundingClientRect = _this5.nodeRef.getBoundingClientRect();
	    var windowWidth = window.innerWidth || html.clientWidth;
	    var windowHeight = window.innerHeight || html.clientHeight;
	
	    var isVisible = _this5.isVisible(boundingClientRect, windowWidth, windowHeight);
	
	    if (isVisible && once) {
	      _this5.removeListener();
	    }
	
	    _this5.setState({ isVisible: isVisible });
	  };
	
	  this.setNodeRef = function (ref) {
	    return _this5.nodeRef = ref;
	  };
	};
	
	exports.default = TrackVisibility;

/***/ }),

/***/ 408:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _TrackVisibility = __webpack_require__(407);
	
	var _TrackVisibility2 = _interopRequireDefault(_TrackVisibility);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _TrackVisibility2.default; /*
	                                             * This file seems a bit useless anyway
	                                             * */

/***/ }),

/***/ 334:
/***/ (function(module, exports) {

	module.exports = {"projects":[{"key":"aca","url":"http://architects.agwaymetals.com/agricultural-colour-application/#/panel/colours/diamond-rib/century-rib/dark-red/green/white-white/a/?_k=z0uoiu","featured":"true","name":"Agway Colour Application","tech":"React, Redux","notes":"Glassroot Creative Media"},{"key":"tulemar","url":"https://tulemar.com/properties/?adlink=true&ptype=private&price_period=week","featured":"true","name":"Tulemar","tech":"React","notes":"<a href=\"http://workwiththey.com\" title=\"Work With They\" rel=\"noopener\" target=\"_blank\">They Integrated</a> "},{"key":"rf","url":"http://rockingfit.com","featured":"true","name":"Rocking Fit","tech":"WordPress, JavaScript","notes":"<a href=\"http://workwiththey.com\" title=\"Work With They\" rel=\"noopener\" target=\"_blank\">They Integrated</a> "},{"key":"hsgo","url":"https://hsgo.ca","featured":"true","name":"HollywoodSuite GO","tech":"WordPress, Akamai, JavaScript","notes":"<a href=\"http://workwiththey.com\" title=\"Work With They\" rel=\"noopener\" target=\"_blank\">They Integrated</a> "},{"key":"cfoffice","url":"https://www.cfoffice.ca","featured":"true","name":"Cadillac Fairview Office Leasing","tech":"React, Code Igniter, PHP","notes":"<a href=\"http://famousfolks.ca\" title=\"Famous Folks\" rel=\"noopener\" target=\"_blank\">Famous Folks</a> "},{"key":"wysiwygco","url":"https://wysiwygco.com","featured":"true","name":"The WYSIWYG Co","tech":"WordPress, JavaScript"},{"key":"agphotos","url":"http://photos.agwaymetals.com/","featured":"true","name":"Agway Metals Photos","tech":"React","notes":"Glassroot Creative Media"},{"key":"ona","url":"https://ontariosnuclearadvantage.com","featured":"true","name":"Ontario's Nuclear Advantage","tech":"WordPress, JavaScript","notes":"<a href=\"http://bigredoak.com\" title=\"Big Red Oak\" rel=\"noopener\" target=\"_blank\">Big Red Oak</a> "},{"key":"p2024","url":"http://pickering2024.com","featured":"true","name":"Pickering 2024","tech":"WordPress, JavaScript","notes":"<a href=\"http://bigredoak.com\" title=\"Big Red Oak\" rel=\"noopener\" target=\"_blank\">Big Red Oak</a> "},{"key":"qac","url":"http://quinteartscouncil.org","name":"Quinte Arts Council","tech":"WordPress, Stripe, JavaScript","notes":"<a href=\"http://workwiththey.com\" title=\"Work With They\" rel=\"noopener\" target=\"_blank\">They Integrated</a> "},{"key":"bionx","url":"http://ridebionx.com/dealers","name":"Bionx","tech":"WordPress, JavaScript, Ember","notes":"<a href=\"http://www.tenfootstudios.com\" title=\"Ten Foot Studios\" rel=\"noopener\" target=\"_blank\">Ten Foot Studios</a> "},{"key":"hws","url":"http://hollywoodsuite.ca","name":"HollywoodSuite","tech":"WordPress, BroadView, JavaScript","notes":"<a href=\"http://workwiththey.com\" title=\"Work With They\" rel=\"noopener\" target=\"_blank\">They Integrated</a> "},{"key":"katie","url":"http://katiecouric.com","name":"Katie Couric","tech":"WordPress, JavaScript","notes":"<a href=\"http://workwiththey.com\" title=\"Work With They\" rel=\"noopener\" target=\"_blank\">They Integrated</a> "},{"key":"lsc","url":"http://www.leadingspasofcanada.com/","name":"Leading Spas of Canada","tech":"WordPress, HTML, CSS, JavaScript","notes":"<a href=\"http://tenfootstudios.com\" title=\"Tewn Foot Studios\" rel=\"noopener\" target=\"_blank\">Ten Foot Studios</a> "},{"key":"savvy","url":"#","name":"Brittany Deal","tech":"WordPress, JavaScript","notes":"<a href=\"http://workwiththey.com\" title=\"Work With They\" rel=\"noopener\" target=\"_blank\">They Integrated</a> "},{"key":"rocco","url":"http://www.davidrocco.com","name":"David Rocco","tech":"WordPress, JavaScript","notes":"<a href=\"http://workwiththey.com\" title=\"Work With They\" rel=\"noopener\" target=\"_blank\">They Integrated</a> "},{"key":"tony-wrighton","url":"http://tonywrighton.com","name":"Tony Wrighton","tech":"WordPress, s2 Member, JavaScript","notes":"<a href=\"http://www.theyinspire.com\" title=\"Work With They\" rel=\"noopener\" target=\"_blank\">They Integrated</a> "},{"key":"candice-kumai","url":"http://www.candicekumai.com","name":"Candice Kumai","tech":"WordPress, JavaScript","notes":"<a href=\"http://www.theyinspire.com\" title=\"Work With They\" rel=\"noopener\" target=\"_blank\">They Integrated</a> "},{"key":"kriscarr","url":"http://kriscarr.com/","name":"Kris Carr","tech":"WordPress, JavaScript","notes":"<a href=\"http://www.theyinspire.com\" title=\"Work With They\" rel=\"noopener\" target=\"_blank\">They Integrated</a> "},{"key":"dcaa","url":"http://dcaa.ca","name":"DCAA","tech":"HTML, CSS, JavaScript, WordPress"},{"key":"hermans-house","url":"http://hermanshousethefilm.com","featured":"false","name":"Herman's House","tech":"WordPress, JavaScript","notes":"<a href=\"http://www.theyinspire.com\" title=\"Work With They\" rel=\"noopener\" target=\"_blank\">They Integrated</a> "},{"key":"oakrun","url":"http://www.oakrun.com","name":"Oakrun Farm Bakery","tech":"HTML, CSS, JavaScript, WordPress"},{"key":"gb","url":"http://www.gourmetbaker.com","name":"Gourmet Baker","tech":"HTML, CSS, JavaScript, WordPress"},{"key":"bghf","url":"http://bghf.ca/","name":"BGHF","tech":"WordPress","notes":"<a href=\"http://www.theyinspire.com\" title=\"Work With They\" rel=\"noopener\" target=\"_blank\">They Integrated</a> "},{"key":"adlf","url":"#","name":"Aboriginal Day Live & Festival","tech":"WordPress","notes":"<a href=\"http://www.theyinspire.com\" title=\"Work With They\" rel=\"noopener\" target=\"_blank\">They Integrated</a> "},{"key":"blackstone","url":"http://www.aptn.ca/pages/blackstone","name":"Blackstone","tech":"WordPress","notes":"<a href=\"http://www.theyinspire.com\" title=\"Work With They\" rel=\"noopener\" target=\"_blank\">They Integrated</a> "},{"key":"restrepo","url":"http://restrepothemovie.com","name":"Restrepo","tech":"PHP","notes":"<a href=\"http://www.theyinspire.com\" title=\"Work With They\" rel=\"noopener\" target=\"_blank\">They Integrated</a> "}]}

/***/ }),

/***/ 200:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StyledButton = function (_Component) {
	  _inherits(StyledButton, _Component);
	
	  function StyledButton() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, StyledButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {}, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  StyledButton.prototype.render = function render() {
	    return _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement(
	        "a",
	        _extends({
	          className: "btn",
	          style: {
	            textDecoration: "none",
	            padding: "12px 20px",
	            lineHeight: "12px",
	            display: "inline-block",
	            verticalAlign: "text-top",
	            fontFamily: "'Roboto', sans-serif",
	            fontSize: "0.9em"
	          }
	        }, this.props),
	        this.props.children
	      )
	    );
	  };
	
	  return StyledButton;
	}(_react.Component);
	
	exports.default = StyledButton;
	module.exports = exports["default"];

/***/ }),

/***/ 202:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LineNumbers = function (_Component) {
	  _inherits(LineNumbers, _Component);
	
	  function LineNumbers() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, LineNumbers);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {}, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  LineNumbers.prototype.render = function render() {
	    var nums = Array.from(new Array(38), function (x, i) {
	      return i + 1;
	    }).splice(24);
	    return _react2.default.createElement(
	      "ul",
	      {
	        className: "lines",
	        style: {
	          listStyleType: "none",
	          width: "30px",
	          maxWidth: "30px",
	          fontFamily: "'Roboto', sans-serif",
	          textAlign: "right",
	          backgroundColor: "rgb(245, 245, 245)",
	          paddingRight: "7px",
	          fontSize: "0.7em",
	          color: "rgba(71, 71, 71,.2)",
	          position: "absolute",
	          left: -70,
	          top: -10,
	          margin: 0,
	          paddingLeft: 0
	        }
	      },
	      nums.map(function (i) {
	        return _react2.default.createElement(
	          "li",
	          { key: i, style: { marginBottom: 0 } },
	          i
	        );
	      })
	    );
	  };
	
	  return LineNumbers;
	}(_react.Component);
	
	exports.default = LineNumbers;
	module.exports = exports["default"];

/***/ }),

/***/ 203:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(310);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Project = function (_Component) {
	  _inherits(Project, _Component);
	
	  function Project() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Project);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {}, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Project.prototype.createMarkup = function createMarkup(html) {
	    return { __html: html };
	  };
	
	  Project.prototype.render = function render() {
	    var _props = this.props,
	        item = _props.item,
	        data = _props.data,
	        img = _props.img;
	
	    return _react2.default.createElement(
	      "section",
	      { className: "project" },
	      _react2.default.createElement(
	        "figure",
	        { className: "project-wrap" },
	        _react2.default.createElement(
	          "a",
	          { title: item.name, target: "_blank", href: item.url, rel: "noopener" },
	          _react2.default.createElement(_gatsbyImage2.default, {
	            style: { display: "inherit" },
	            className: "project-img project-shadow",
	            sizes: img.sizes
	          })
	        ),
	        _react2.default.createElement(
	          "figcaption",
	          { className: "project-details" },
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "Project: "
	            ),
	            item.name,
	            _react2.default.createElement(
	              "span",
	              { className: "project-tech" },
	              "(",
	              item.tech,
	              ")"
	            ),
	            _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                "strong",
	                null,
	                "Agency: "
	              ),
	              _react2.default.createElement("span", { dangerouslySetInnerHTML: this.createMarkup(item.notes) })
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Project;
	}(_react.Component);
	
	exports.default = Project;
	module.exports = exports["default"];

/***/ }),

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Skills = function (_Component) {
	  _inherits(Skills, _Component);
	
	  function Skills() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Skills);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {}, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Skills.prototype.render = function render() {
	    return _react2.default.createElement(
	      "div",
	      { className: "skills-list" },
	      _react2.default.createElement(
	        "ul",
	        { className: "custom-bullet" },
	        _react2.default.createElement(
	          "li",
	          null,
	          "JavaScript (React, Vue, Ember, Node)"
	        ),
	        _react2.default.createElement(
	          "li",
	          null,
	          "Apps (React Native, Cordova) "
	        ),
	        _react2.default.createElement(
	          "li",
	          null,
	          "GraphQL, MongoDB, MySQL"
	        )
	      ),
	      _react2.default.createElement(
	        "ul",
	        { className: "custom-bullet" },
	        _react2.default.createElement(
	          "li",
	          null,
	          "HTML / CSS"
	        ),
	        _react2.default.createElement(
	          "li",
	          null,
	          "PHP (Laravel, Symfony, WordPress)"
	        ),
	        _react2.default.createElement(
	          "li",
	          null,
	          "Test-driven development (TDD)"
	        )
	      )
	    );
	  };
	
	  return Skills;
	}(_react.Component);
	
	exports.default = Skills;
	module.exports = exports["default"];

/***/ }),

/***/ 205:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Social = function (_Component) {
	  _inherits(Social, _Component);
	
	  function Social() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Social);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {}, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Social.prototype.render = function render() {
	    var isVisible = this.props.isVisible;
	
	
	    var classes = isVisible ? "is-visible" : "not-visible";
	
	    return _react2.default.createElement(
	      "ul",
	      {
	        className: "social-icons " + classes,
	        style: {
	          display: "flex",
	          justifyContent: "space-between",
	          listStyle: "none",
	          marginTop: "50px"
	        }
	      },
	      _react2.default.createElement(
	        "li",
	        null,
	        _react2.default.createElement(
	          "a",
	          { href: "https://twitter.com/timarney", title: "twitter" },
	          _react2.default.createElement(
	            "svg",
	            {
	              style: { paddingTop: "2px" },
	              xmlns: "http://www.w3.org/2000/svg",
	              viewBox: "0 0 612 612"
	            },
	            _react2.default.createElement("path", {
	              d: "M612 116.258c-22.525 9.98-46.694 16.75-72.088 19.772 25.93-15.527 45.777-40.155 55.184-69.41-24.322 14.378-51.17 24.82-79.775 30.48-22.906-24.438-55.49-39.66-91.63-39.66-69.333 0-125.55 56.218-125.55 125.514 0 9.828 1.11 19.427 3.25 28.606-104.325-5.24-196.834-55.223-258.75-131.174-10.822 18.51-16.98 40.078-16.98 63.1 0 43.56 22.182 81.994 55.836 104.48-20.575-.688-39.926-6.348-56.867-15.756v1.568c0 60.806 43.29 111.554 100.692 123.104-10.517 2.83-21.607 4.398-33.08 4.398-8.107 0-15.947-.803-23.634-2.333 15.985 49.907 62.336 86.2 117.253 87.194-42.946 33.655-97.098 53.656-155.915 53.656-10.134 0-20.116-.612-29.944-1.72 55.568 35.68 121.537 56.484 192.44 56.484 230.947 0 357.187-191.29 357.187-357.188l-.42-16.253C573.87 163.525 595.21 141.42 612 116.257z",
	              fill: "#010002"
	            })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "li",
	        null,
	        _react2.default.createElement(
	          "a",
	          { href: "https://github.com/timarney", title: "github" },
	          _react2.default.createElement(
	            "svg",
	            {
	              xmlns: "http://www.w3.org/2000/svg",
	              viewBox: "0 1.787 800 799.213"
	            },
	            _react2.default.createElement("ellipse", {
	              fill: "#f5f5f5",
	              cx: "400.106",
	              cy: "410.145",
	              rx: "394.606",
	              ry: "390.855"
	            }),
	            _react2.default.createElement("path", { d: "M746.338 201.004c-35.77-61.286-84.287-109.806-145.567-145.57-61.29-35.768-128.2-53.647-200.778-53.647-72.567 0-139.497 17.885-200.775 53.646-61.286 35.763-109.802 84.285-145.57 145.57C17.882 262.29 0 329.21 0 401.77c0 87.16 25.43 165.537 76.3 235.15 50.867 69.618 116.578 117.792 197.13 144.525 9.375 1.74 16.317.516 20.832-3.642 4.513-4.162 6.768-9.376 6.768-15.618 0-1.04-.09-10.413-.263-28.124-.18-17.712-.263-33.163-.263-46.345l-11.98 2.072c-7.637 1.4-17.274 1.992-28.905 1.824-11.63-.163-23.7-1.38-36.2-3.647-12.502-2.243-24.133-7.45-34.896-15.61-10.76-8.16-18.397-18.84-22.912-32.026l-5.208-11.985c-3.47-7.98-8.938-16.843-16.403-26.56-7.466-9.724-15.016-16.316-22.656-19.788l-3.645-2.608c-2.43-1.736-4.686-3.83-6.77-6.257-2.084-2.427-3.644-4.858-4.687-7.292-1.04-2.436-.177-4.433 2.605-6.002 2.782-1.565 7.808-2.326 15.104-2.326l10.412 1.557c6.945 1.392 15.535 5.55 25.782 12.496 10.243 6.944 18.66 15.97 25.26 27.076 7.99 14.24 17.616 25.09 28.906 32.558 11.28 7.466 22.656 11.193 34.112 11.193s21.35-.868 29.685-2.596c8.327-1.732 16.14-4.345 23.435-7.814 3.125-23.273 11.633-41.154 25.517-53.65-19.787-2.08-37.58-5.21-53.382-9.376-15.794-4.17-32.115-10.938-48.952-20.32-16.847-9.372-30.822-21.01-41.93-34.89-11.108-13.89-20.226-32.125-27.338-54.69-7.114-22.57-10.675-48.61-10.675-78.12 0-42.022 13.718-77.78 41.148-107.295-12.85-31.593-11.638-67.007 3.643-106.242 10.07-3.13 25.002-.78 44.792 7.028 19.792 7.815 34.284 14.508 43.49 20.057 9.204 5.545 16.58 10.25 22.136 14.06 32.3-9.023 65.63-13.535 100.002-13.535 34.374 0 67.707 4.51 100.007 13.536l19.792-12.496c13.532-8.337 29.516-15.975 47.903-22.92 18.406-6.942 32.477-8.853 42.203-5.727 15.62 39.24 17.012 74.653 4.16 106.242 27.427 29.516 41.15 65.285 41.15 107.296 0 29.512-3.572 55.632-10.677 78.378-7.114 22.748-16.31 40.966-27.592 54.69-11.29 13.717-25.354 25.264-42.192 34.63-16.843 9.378-33.17 16.146-48.96 20.313-15.805 4.17-33.596 7.304-53.385 9.387 18.05 15.62 27.075 40.274 27.075 73.953v109.884c0 6.243 2.17 11.456 6.516 15.62 4.342 4.154 11.193 5.38 20.57 3.637 80.56-26.73 146.272-74.904 197.137-144.523 50.86-69.612 76.3-147.99 76.3-235.15-.02-72.55-17.91-139.468-53.657-200.753h-.005z" })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "li",
	        null,
	        _react2.default.createElement(
	          "a",
	          { href: "https://www.linkedin.com/in/timarney/", title: "linkedin" },
	          _react2.default.createElement(
	            "svg",
	            { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 800 800" },
	            _react2.default.createElement("ellipse", {
	              fill: "#F5F5F5",
	              cx: "399.498",
	              cy: "412.684",
	              rx: "382.002",
	              ry: "376.816"
	            }),
	            _react2.default.createElement("path", { d: "M740.923 0H59.113C26.47 0 .006 25.654.006 57.318v685.337c0 31.668 26.47 57.343 59.11 57.343h681.808c32.643 0 59.072-25.69 59.072-57.343V57.32c0-31.657-26.43-57.318-59.072-57.318V0zM242.54 669.654H121.665v-361.19H242.54v361.19zM182.114 259.12h-.813c-40.534 0-66.81-27.72-66.81-62.426 0-35.404 27.047-62.374 68.385-62.374 41.34 0 66.772 26.962 67.572 62.374 0 34.712-26.222 62.426-68.335 62.426zm496.137 410.534H557.416v-193.25c0-48.557-17.508-81.688-61.205-81.688-33.428 0-53.272 22.352-61.986 43.933-3.23 7.706-4.03 18.486-4.03 29.252v201.745H309.386s1.58-327.314 0-361.188h120.828v51.204c16.04-24.604 44.704-59.705 108.87-59.705 79.532 0 139.166 51.594 139.166 162.587v207.105l.002.002zm-248.82-308.842c.204-.338.494-.744.78-1.142v1.142h-.78z" })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "li",
	        null,
	        _react2.default.createElement(
	          "a",
	          { href: "https://medium.com/@timarney", title: "medium.com" },
	          _react2.default.createElement(
	            "svg",
	            {
	              style: { paddingTop: "5px" },
	              xmlns: "http://www.w3.org/2000/svg",
	              viewBox: "0 0 800 800"
	            },
	            _react2.default.createElement("path", { d: "M800 85.714h-44.145c-11.49 0-41.57 12.486-41.57 23.114v386.01c0 10.655 30.075 19.394 41.57 19.394h44.147v85.7H514.284V514.23h57.157V114.268h-9.945L423.957 599.93H317.47L181.713 114.268h-10.284v399.958h57.134v85.705H0v-85.704h31.7c12.445 0 25.434-8.732 25.434-19.39V108.83c0-10.63-12.987-23.114-25.434-23.114H0V0h296.21l96.714 342.813h2.604L493.198 0H800v85.714z" })
	          )
	        )
	      )
	    );
	  };
	
	  return Social;
	}(_react.Component);
	
	exports.default = Social;
	module.exports = exports["default"];

/***/ }),

/***/ 206:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _Button = __webpack_require__(200);
	
	Object.defineProperty(exports, "StyledButton", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Button).default;
	  }
	});
	
	var _LineNumbers = __webpack_require__(202);
	
	Object.defineProperty(exports, "LineNumbers", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_LineNumbers).default;
	  }
	});
	
	var _Project = __webpack_require__(203);
	
	Object.defineProperty(exports, "Project", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Project).default;
	  }
	});
	
	var _Skills = __webpack_require__(204);
	
	Object.defineProperty(exports, "Skills", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Skills).default;
	  }
	});
	
	var _Social = __webpack_require__(205);
	
	Object.defineProperty(exports, "Social", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Social).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 209:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(155);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _components = __webpack_require__(206);
	
	var _reactOnScreen = __webpack_require__(408);
	
	var _reactOnScreen2 = _interopRequireDefault(_reactOnScreen);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pData = __webpack_require__(334);
	
	function findNode(images, key) {
	  var l = "";
	  images.forEach(function (el, index) {
	    var oName = images[index].node.sizes.originalName;
	    if (oName === key + ".jpg") {
	      l = images[index].node;
	    }
	  });
	
	  return l;
	}
	
	var IndexPage = function IndexPage(d) {
	  var _ref;
	
	  var images = d.data.allImageSharp.edges;
	
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "div",
	      { className: "wrapper" },
	      _react2.default.createElement(
	        "div",
	        { className: "main-text-wrap" },
	        _react2.default.createElement(
	          "div",
	          { className: "main-text" },
	          _react2.default.createElement(_components.LineNumbers, null),
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "h2",
	              { style: { marginBottom: "10px" } },
	              "ABOUT"
	            ),
	            _react2.default.createElement("span", {
	              className: "keyline",
	              style: {
	                margin: "15px 0px",
	                width: "60px",
	                height: "2px",
	                backgroundColor: "#e8e8e8"
	              }
	            })
	          )
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Not sure where to start on a project (big or small)? We are here to help."
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "We strive to create flexible, intuitive, accessible websites and apps for our clients that stand the test of time. Whether a project is big or small, needs a programmer or designer (or both); our team of experts are here to make your ideas come to fruition."
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Working with our clients over the past 15 years, we've had the privilege of creating functional, beautiful digital solutions. Throughout an entire project lifecycle, we take the care and time to ensure our work aligns with our clients best interests."
	        ),
	        _react2.default.createElement(
	          "h2",
	          { style: { fontSize: "0.9em" } },
	          "Core Skills"
	        ),
	        _react2.default.createElement(_components.Skills, null)
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "social-bkd" },
	      _react2.default.createElement(
	        "div",
	        { className: "wrapper" },
	        _react2.default.createElement(
	          "div",
	          { className: "main-text-wrap" },
	          _react2.default.createElement(
	            _reactOnScreen2.default,
	            null,
	            _react2.default.createElement(_components.Social, null)
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { style: { backgroundColor: "#f5f5f5", paddingTop: "50px" } },
	      _react2.default.createElement(
	        "div",
	        { style: { display: "flex", justifyContent: "center" } },
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "h2",
	            null,
	            "Projects"
	          ),
	          _react2.default.createElement("span", {
	            style: (_ref = {
	              display: "block",
	              margin: "15px 0px",
	              width: "100px",
	              height: "2px",
	              backgroundColor: "#e8e8e8",
	              textAlign: "center"
	            }, _ref["margin"] = "0 auto", _ref)
	          })
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        {
	          style: {
	            display: "flex",
	            flexWrap: "wrap",
	            justifyContent: "center"
	          }
	        },
	        pData.projects.map(function (project, index) {
	          var img = findNode(images, project.key);
	          return _react2.default.createElement(_components.Project, { key: project.key, item: project, img: img });
	        })
	      )
	    )
	  );
	};
	
	var query = exports.query = "** extracted graphql fragment **";
	
	exports.default = IndexPage;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-73209d168d84c00709ad.js